import Choices from "choices.js";
import { suppressChoicesSearchAutofill } from "../form-autofill";

const buildSearchableSelect = ({
    searchPlaceholder = "Search…",
} = {}) => ({
    instance: null,
    open: false,

    init() {
        const select = this.$refs.select;

        if (!(select instanceof HTMLSelectElement)) {
            return;
        }

        this.instance = new Choices(select, {
            searchEnabled: true,
            searchChoices: true,
            shouldSort: false,
            allowHTML: false,
            itemSelectText: "",
            placeholder: true,
            searchPlaceholderValue: searchPlaceholder,
            position: "auto",
        });

        suppressChoicesSearchAutofill(this.instance);

        if (select.disabled) {
            this.instance.disable();
        }

        const element = this.instance.passedElement.element;

        element.addEventListener(
            "change",
            (event) => {
                if (!(event instanceof CustomEvent) || event.detail == null || typeof event.detail !== "object") {
                    return;
                }

                event.stopImmediatePropagation();
                element.dispatchEvent(new Event("change", { bubbles: true }));
            },
            true,
        );

        element.addEventListener("showDropdown", () => {
            this.open = true;
        });

        element.addEventListener("hideDropdown", () => {
            this.open = false;
        });
    },

    destroy() {
        this.instance?.destroy();
        this.instance = null;
    },
});

export const registerSearchableSelect = (Alpine) => {
    Alpine.data("searchableSelect", (config) => buildSearchableSelect(config));
};
